import { render } from "./RichiestaDetail.vue?vue&type=template&id=42ea0d52&scoped=true"
import script from "./RichiestaDetail.vue?vue&type=script&lang=js"
export * from "./RichiestaDetail.vue?vue&type=script&lang=js"

import "./RichiestaDetail.vue?vue&type=style&index=0&id=42ea0d52&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ea0d52"]])

export default __exports__